module.exports = __webpack_public_path__ + "img/bluuu_logo.9cea2b0f.png";